import DialogWrapper from '../../../core/dialog/dialog_wrapper';
import { ImportRoutine } from '../ImportRoutine';
import { ImportStructureEditor } from './ImportStructureEditor';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { StructureService } from '../../../services/structure_service';
import style from '../import_tool.less';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WTable } from '../../table/WTable';

interface ImportStepFileTransformProps extends React.ClassAttributes<any> {
    modul: string;
    data: any;
    onDataChange: (data: any) => void;
    onDone: () => void;
    hideCreateStructure?: boolean;
    whitelistStructures?: Array<string>;
}

interface ImportStepFileTransformState {
    sheetData: Array<any>;
    selectedRow?: Array<number>;
    selectedStructure?: string;
    structures?: Array<any>;
    columns: Array<any>;
    showStructureForm: boolean;
}

export class ImportStepFileTransform extends React.Component<ImportStepFileTransformProps, ImportStepFileTransformState> {

    constructor(props: any) {
        super(props);
        this.onSelection = this.onSelection.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.onChange = this.onChange.bind(this);
        this.loadStructureNames = this.loadStructureNames.bind(this);
        this.state = {
            sheetData: [],
            columns: [],
            selectedRow: this.props.data.headerRow ? this.props.data.headerRow : undefined,
            selectedStructure: this.props.data.structureKey ? this.props.data.structureKey : '-1',
            showStructureForm: false
        };
    }

    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(ImportRoutine) private importRoutine: ImportRoutine;

    private debug = false;

    componentDidMount() {
        const sheetName = this.props.data.sheetName;
        const sheetData = this.props.data.sheetDataAll[sheetName];
        if (this.debug) {
            console.log(sheetData);
            console.log(sheetName);
        }
        const columns = this.generateColumns(sheetData);
        this.setState({ sheetData, columns });
        this.loadStructureNames();
        this.triggerService.register('structure_reload', 'ALL', () => this.loadStructureNames());
    }

    loadStructureNames() {
        const whitelist = this.props.whitelistStructures || [];
        let structures = this.structureService.getStructureNames(this.props.modul, true);
        structures = whitelist.length
            ? structures.filter((item: any) => whitelist.indexOf(item.key) !== -1)
            : structures;
        this.setState({ structures });
    }

    render() {
        if (!this.state.sheetData || this.state.sheetData.length === 0 || !this.state.structures) {
            return (
                <div>
                    Daten werden vorbereitet.
                </div>
            );
        }
        const chooseDisabled = (!this.state.selectedRow || this.state.selectedRow.length === 0) || !this.state.selectedStructure
            || this.state.selectedStructure === '-1';
        const createDisabled = this.state.showStructureForm || (!this.state.selectedRow || this.state.selectedRow.length === 0);
        const isWhitelistPreselected = this.state.selectedStructure && this.state.selectedStructure !== '-1'
            && (this.props.whitelistStructures || []).length === 1;
        return (
            <div>
                <div className={style.infobox}>
                    <input
                        style={{
                            padding: 10, backgroundColor: chooseDisabled ? '#aaa' : '#afa', border: '2px solid #0a0', borderRadius: 5,
                            color: '#080', fontWeight: 'bold', width: 420
                        }}
                        type='button'
                        value={chooseDisabled ? 'Kopfzeile und Zieldatenstruktur auswählen' : 'Weiter'}
                        disabled={chooseDisabled}
                        onClick={() => this.onFinish()}

                    />
                    <br />
                    <br />
                    {(!this.state.selectedRow || this.state.selectedRow.length === 0) &&
                        <div style={{ color: '#a00',  fontWeight: 'bold' }}>
                            {`${!isWhitelistPreselected ? 'Schritt 1: ' : ''}Wählen Sie in der Tabelle (unten) die Kopfzeile(n) für Ihre Import-Daten aus.`}
                        </div>
                    }
                    {(!this.state.selectedStructure || this.state.selectedStructure === '-1') &&
                        <div style={{ color: '#a00', fontWeight: 'bold' }}>
                            Schritt 2: Wählen Sie im Drop-Down Menü die "Zieldatenstruktur"{this.renderZieldatenstrukturListe(2)}
                        </div>
                    }
                    {!isWhitelistPreselected &&
                        <>
                            <br />
                            Zieldatenstruktur:&nbsp;
                            <select
                                onChange={this.onChange}
                                value={this.state.selectedStructure}
                            >
                                <option
                                    value={-1}
                                >
                                    Bitte wählen
                                </option>
                                {this.state.structures.map((s, idx) =>
                                    <option
                                        key={`opt_struct_${idx}`}
                                        value={s.key}
                                    >
                                        {s.name}
                                    </option>
                                )}
                            </select>
                        </>
                    }
                    {!this.props.hideCreateStructure &&
                        <input
                            style={{
                                padding: 5, backgroundColor: createDisabled ? '#aaa' : '#aaf', border: '2px solid #00a', borderRadius: 5,
                                color: '#008', fontWeight: 'bold'
                            }}
                            type='button'
                            value='Neue Struktur aus Daten erstellen'
                            onClick={() => this.setState({ showStructureForm: true })}
                            disabled={createDisabled}
                        />
                    }
                </div>
                <WTable
                    entity=''
                    columns={this.state.columns}
                    onAction={this.onAction}
                    data={this.state.sheetData}
                    customClass='Custom-ETA'
                    multipleSelection={true}
                    onSelection={this.onSelection}
                    selectedRowForArray={this.state.selectedRow}
                />
                {this.state.showStructureForm &&
                    <div>
                    <DialogWrapper
                        onAfterClose={() => this.setState({ showStructureForm: false })}
                    >
                        <ImportStructureEditor
                            modul={this.props.modul}
                            entityNameSuggestion={this.props.data.sheetName}
                            titleRow={this.state.selectedRow}
                            data={this.state.sheetData}
                            onDialogClose={() => this.setState({ showStructureForm: false })}
                        />
                    </DialogWrapper>
                    </div>
                }
            </div>
        );
    }

    renderZieldatenstrukturListe(limit: number) {
        const structures: Array<any> = this.state.structures || [];
        let text: string = '';
        if (structures.length) {
            structures.forEach((item: any, index: number) => {
                if ((index + 1) > limit || typeof item.name === 'undefined') {
                    return;
                }
                text += `${item.name}/`;
            });
            text = text.slice(0, -1);
            text = text.length && (structures.length > limit) ? `${text}/...` : text;
        }
        return text ? ` (${text})` : text;
    }

    onChange(event: any) {
        const selectedStructure = event.target.value + '';
        this.setState({ selectedStructure });
    }

    onSelection(selectedRow: any) {
        this.setState({ selectedRow });
    }

    onFinish() {
        const data = this.props.data;
        data.headerRow = this.state.selectedRow;
        data.structureKey = this.state.selectedStructure;
        data.checkDaten = true;
        const sheetName = data.sheetName;
        const headerRow = data.headerRow;
        const sheetData = data.sheetDataAll[sheetName];
        const fieldData = this.importRoutine.getFieldData(data.headerRow, sheetData);
        const doubles = fieldData.filter((item: string, idx: number) => fieldData.indexOf(item) !== idx);
        if (doubles && doubles.length > 0) {
            const strDoubles = doubles.join(', ');
            alert(`Die gewählte Tabelle kann nicht verwendet werden, da doppelte Spalten enthalten sind: ${strDoubles}`);
            return;
        }
        this.props.onDataChange(data);
        this.props.onDone();
    }

    onAction(action: string, row: any) {
        // Actions gibt es vorerst nicht
    }

    generateColumns(sheetData: Array<any>) {
        // sheetData.forEach((s) => {console.log(s.length); console.log(s)});
        const maxCol = sheetData.reduce((total, value) => value.length > total.length ? value : total);
        const columns = new Array<any>();
        for (let i = 0; i < maxCol.length; i++ ) {
            const acc = i;
            const item: any = { accessor:  acc + '', Header: `Spalte ${i}`, id: `spalte${i}` };
            columns.push(item);
        }
        return columns;
    }
}
